module.exports = __webpack_public_path__ + "img/wcar.205311ea.png";